import React from 'react';

/// This is a subfooter for mortgage only
const subfooterStyle = { textAlign: 'center', fontSize: 'small', marginTop: '2rem', fontWeight: 500 };
const subfooterText =
  'If you need help or have questions, please contact our Mortgage team for assistance at (800) 506-5070.';
const SubFooter = () => (
  <div style={subfooterStyle}>
    <small>{subfooterText}</small>
  </div>
);

export default SubFooter;
